// extracted by mini-css-extract-plugin
export var deleteModal = "_ff-0";